import { render, staticRenderFns } from "./Subcontractors.vue?vue&type=template&id=640907e0"
import script from "./Subcontractors.vue?vue&type=script&lang=js"
export * from "./Subcontractors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports